import { render, staticRenderFns } from "./LoginForUser.vue?vue&type=template&id=3ca4e1c3"
import script from "./LoginForUser.vue?vue&type=script&lang=js"
export * from "./LoginForUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports